import * as Yup from "yup";

export const termsValidation = Yup.object().shape({
  title: Yup.string().required("وارد کردن عنوان الزامی است"),
  part: Yup.string().required("وارد کردن دسته‌بندی الزامی است"),
});
